import React, { useContext } from 'react'
import SignupContext from 'modules/react/signup/SignupContext'
import RightContentEmployee from 'modules/react/signup/RightContentEmployee'

export default function Step1RightContent () {

  const { course } = useContext(SignupContext)

  return (
    <>
      <div className="title title--h4">Bliv kontaktet</div>
      <div className="wysiwyg">Når du skriver dig på ventelisten, vil du blive kontaktet når det igen er muligt at
        tilmelde sig <b>{course.post_title}</b></div>
      <RightContentEmployee/>
    </>
  )
}